module.exports = __webpack_public_path__ + "img/pr-2.22facb3d.png";